/**
 * KEY==Value for equality checks
 */
export enum ImplementAccountingModeEnum {
   SUM = 'SUM',
  MEDIAN = 'MED',
  AVERAGE = 'AVG',
  MAX = 'MAX',
  MIN = 'MIN'
}
